// extracted by mini-css-extract-plugin
export default {"HeaderLevel3":"HeaderLevel3__HeaderLevel3___rWk5l","centered":"HeaderLevel3__centered___F50pz"};